import { Car } from '@/types/cars.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface carState {
    selectedCar: Car | null;
}

const initialState: carState = {
    selectedCar: null,
};

const carSlice = createSlice({
    name: 'car',
    initialState,
    reducers: {
        selectCar: (state, action: PayloadAction<Car>) => {
            state.selectedCar = action.payload;
        },
        RemoveSelectedCar: (state) => {
            state.selectedCar = null;
        },
    },
});

export const { selectCar, RemoveSelectedCar } = carSlice.actions;
export default carSlice.reducer;
